import Core from "Core";
import ModalHandler from "./ModalHandler";

export default class ErrorDetailHandler extends ModalHandler {
  constructor(error) {
    super(Core.Components.Modals.ErrorDetail);

    this.error = error;

    this.glyph = "exclamation-sign";

    this.modalProps = {
      backdrop: true
    };
  }
}



// WEBPACK FOOTER //
// ./src/Core/Stores/ModalsStore/ErrorDetailHandler.js